<h2>Modalities</h2>
<div *ngIf="activeModalities.length > 0; else noModalities">
  <mat-card *ngFor="let modality of activeModalities" class="modality-card">
    <mat-card-header>
      <mat-icon mat-card-avatar color="primary">check_circle</mat-icon>
      <mat-card-title>Modalities</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="modality-details">
        <p><strong>Modality:</strong> {{ modality.modalityDisplay }}</p>
        <p><strong>Effective Date:</strong> {{ modality.effectiveDate | date: 'MM/dd/yyyy' }}</p>
        <p><strong>End Datetime GMT:</strong> {{ modality.endDateTimeGmt || 'None'}}</p>
        <p><strong>Facility Number:</strong> {{ modality.facilityNumberDocumentAt || 'None'}}</p>
        <mat-divider></mat-divider>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #noModalities>
  <div class="no-data-message">
    <mat-icon>info</mat-icon>
    <p>No active modalities found for this patient.</p>
  </div>
</ng-template>
